export default __webpack_public_path__ + "static/mumbai-cover-b88f29b0de1e0699c2203cf9c1951930.jpg";